module.exports = __webpack_public_path__ + "img/magento-security-services@2x.7cf29165.jpeg";